export const blockIconsAudioandvideoStopCircleNew = (
	<span className='material-symbols-outlined'>stop_circle</span>
);
